import React, { useState } from 'react'
import './AddCirclePage.css'
import { Container, Row, Col } from 'react-bootstrap'
import AdminHeader from '../../components/adminHeader/AdminHeader'
import AdminSideBar from '../../components/adminSide/AdminSideBar'
import AddCircle from '../../components/addcircle/AddCircle'
import AddCircleGetApi from '../../components/addcirclegetapi/AddCircleGetApi'
import { AddCircleContext } from '../../contexts/AddCircleContext'


export default function AddCirclePage() {
  const [dayerhCode, SetDayerhCode] = useState([])      //the array to collect a code of every circle until 16code
  const [addCirFlag, setAddCirFlag] = useState(false)     // <=to update state of get api after post api 
  const [addCirFlag2, setAddCirFlag2] = useState(false)     // <=to update state of get api after post api 
  const [addCirFlag3, setAddCirFlag3] = useState(false)     // <=to update state of get api after post api 
  const [addCirFlag4, setAddCirFlag4] = useState(false)     // <=to update state of get api after post api 
  const [addCirFlag5, setAddCirFlag5] = useState(false)     // <=to update state of get api after post api 
  const [idToApiPut, setIdToApiPut] = useState('')     // <=to update state of get api after post api 
  const [srcToApiPut, setSrcToApiPut] = useState([])     // <=to update state of get api after post api 

  return (
    <AddCircleContext.Provider value={{
      dayerhCode, SetDayerhCode,
      addCirFlag, setAddCirFlag,
      addCirFlag2, setAddCirFlag2,
      addCirFlag3,setAddCirFlag3,
      idToApiPut, setIdToApiPut,
      srcToApiPut, setSrcToApiPut,
      addCirFlag4, setAddCirFlag4,
      addCirFlag5, setAddCirFlag5
    }}>
      <Container fluid noGutters={true} >
        <Row noGutters={true}>
          <Col xs={2}>
            <AdminSideBar />
          </Col>
          <Col xs={10}>
            <AdminHeader />
            <Row>
              <Col xs={5} className='addcirclepage-col5' >
                <AddCircle />
              </Col>
              <Col xs={6}>
                <AddCircleGetApi />
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </AddCircleContext.Provider>
  )
}
